import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Room } from '../../models';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class ParticipantsService {
  public participants$ = new Subject<Array<any>>();
  public statusConection$ = new Subject<boolean>();
  public openOrCloseUserList$ = new Subject<boolean>();
  public showTooltipListUser: boolean = false;
  public participantsData: any[] = [];
  private ids: string[] = [];

  constructor(private readonly utils: UtilsService) {}

  // Method that set the participants that are found in the actived streams
  public setParticipants(
    participants: Array<any>,
    roomData: Room,
    disconnected?: boolean
  ): void {
    participants.push({
      name: roomData.attendantName,
      id: 'publisher',
      rol: 'publisher',
      disconnected: disconnected,
    });

    this.participants$.next(participants);
  }

  // We get the participants Streams
  public getParticipants(): Subject<Array<any>> {
    return this.participants$;
  }

  public resetParticipants() {
    this.participants$.unsubscribe();
    this.participants$ = new Subject<Array<any>>();
  }

  // We format the participants Streams to get the names of them for the header
  public getNames(participants: Array<any>) {
    // tslint:disable-next-line:prefer-const
    let participantsData: any[] = [];

    participants.forEach((participant) => {
      participant = {
        name: participant.name,
        initials: this.utils.getInitials(participant.name),
        color: this.utils.getColor(),
        id: participant.id,
        disconnected: participant.disconnected,
      };

      participantsData.push(participant);
    });
    participantsData[0].color = '#dc752d';

    return participantsData;
  }

  // Method that check the exist participants to assign the same color.
  checkExistParticipant(participant: any) {
    if (!this.ids.length || this.ids.indexOf(participant.id) === -1) {
      participant = {
        name: participant.name,
        initials: this.utils.getInitials(participant.name),
        color: this.utils.getColor(),
        id: participant.id,
        disconnected: participant.disconnected,
      };

      if (participant.id !== 'publisher') {
        participant.rol = 'subscriber';
      }

      this.ids.push(participant.id);
      this.participantsData.push(participant);
    }

    // if (participant.disconnected) {
    //   const idx = this.participantsData.indexOf(participant.id);
    //   this.participantsData.splice(idx, 1);
    // }

    return this.participantsData;
  }

  // Set the state of user list, opened or closed
  setCloseOpenUserList(state: boolean) {
    this.showTooltipListUser = state;
    this.openOrCloseUserList$.next(state);
  }

  // returns the subscribe to the user list state
  getCloseOpenUserList(): Subject<boolean> {
    return this.openOrCloseUserList$;
  }
}
